import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderTracker } from '@models/shopping-cart.model';

@Component({
  selector: 'ts-order-tracker',
  templateUrl: './order-tracker.component.html',
  imports: [CommonModule]
})
export class OrderTrackerComponent {
  @Input() order_tracker_config: OrderTracker[];
}
